var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"center"}},[_c('notice-card',{attrs:{"notice":_vm.notice}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }